import Modifier from 'ember-modifier';
import tippy from 'tippy.js';

export default class Tippy extends Modifier {
  modify(element, [content], namedArgs) {
    if (!this.element) {
      this.element = element;
    }

    let options = {
      showOnCreate: false,
      placement: 'bottom',
      interactive: true,
      ...namedArgs,
      content,
    };

    if (['div', 'span'].includes(this.element.tagName)) {
      this.element.setAttribute('tabindex', '0');
    }

    if (this.element._tippy) {
      this.element._tippy.destroy();
    }

    tippy(this.element, options);
  }
}
